import { RestProvider } from 'dataSources/types/restProvider';
import { BaseResource } from 'e100-data-providers';

import { StationWithPrices, FavouriteStation } from '../types';
import { IStationInfo } from 'dataSources/Typicode/stations';

export class StationsApi extends BaseResource {
  path: string = '';

  constructor(provider: RestProvider) {
    super(provider);
    this.path = '';
  }

  async getStationsWithPrices(): Promise<StationWithPrices[]> {
    const autocompleteResponse = (await fetch('/assets/data/stationsWithPrices.json')) as any;
    const data = await autocompleteResponse.json();
    return data;
  }

  async getStationsInformation(stationCodes: string[]): Promise<IStationInfo[]> {
    return Promise.all(stationCodes.map((code) => this.getChildResource(`stations/${code}`).getItems()));
  }

  getFavouriteStations(): Promise<{ favouriteStations: FavouriteStation[] }> {
    return this.getChildResource('favourite/stations').getItems();
  }

  addFavouriteStations(stationCodes: FavouriteStation['stationCode'][]): Promise<{ favouriteStations: FavouriteStation[] }> {
    return this.send(this.getChildResource('favourite/stations').request.put().setBody(stationCodes));
  }

  deleteFavouriteStations(stationCodes: FavouriteStation['stationCode'][]): Promise<{ favouriteStations: FavouriteStation[] }> {
    return this.send(this.getChildResource('favourite/stations').request.del().setBody(stationCodes));
  }
}
